import { gql, useMutation } from "@apollo/client";

import { normalizeErrors } from "../../../utils/normalizeErrors";
import { NormalizedErrorMap } from "../../../types/NormalizedErrorMap";
import { PushSubscriptionProvider } from "../constants";

interface DisableMyPushSubscriptionsMutation {
  disableMyPushSubscriptions: {
    errors: Array<{ path: string; message: string }> | null;
    message: string | null;
  };
}

interface DisableMyPushSubscriptionsVariables {
  provider?: PushSubscriptionProvider;
}

export const disableMyPushSubscriptionsMutation = gql`
  mutation DisableMyPushSubscriptionsMutation($provider: String) {
    disableMyPushSubscriptions(provider: $provider) {
      errors {
        path
        message
      }
      message
    }
  }
`;

export function useDisableMyPushSubscriptions() {
  const [mutate, { loading, error, data }] = useMutation<
    DisableMyPushSubscriptionsMutation,
    DisableMyPushSubscriptionsVariables
  >(disableMyPushSubscriptionsMutation);

  const disableMyPushSubscriptions = async (provider?: PushSubscriptionProvider) => {
    const { data: mutationData } = await mutate({
      variables: provider ? { provider } : {},
    });

    const result = mutationData?.disableMyPushSubscriptions;
    const errors = result?.errors ? normalizeErrors(result.errors) : null;

    return {
      errors: errors as NormalizedErrorMap | null,
      message: result?.message ?? undefined,
    };
  };

  return {
    disableMyPushSubscriptions,
    loading,
    error,
    message: data?.disableMyPushSubscriptions?.message || null,
  };
}
